"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _FormRows = _interopRequireDefault(require("./FormRows"));
var _RenderHeaderGroup = _interopRequireDefault(require("./RenderHeaderGroup"));
var _TableTitle = _interopRequireDefault(require("../tanstack/TableTitle"));
var _TableFooter = _interopRequireDefault(require("../tanstack/TableFooter"));
var _tableContext = require("../../Context/tableContext");
var _Helpers = require("../../Helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function EmreTable(props) {
  var expandable = props.expandable,
    prefixCls = props.prefixCls,
    emptyText = props.emptyText,
    scroll = props.scroll,
    defaultWrapperClass = props.defaultWrapperClass,
    containerWrapperClass = props.containerWrapperClass;
  var onExpandByFilter = expandable.onExpandByFilter;
  var _useState = (0, _react.useState)(getDefaultColumns()),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    columns = _useState2[0],
    setColumns = _useState2[1];
  var _useState3 = (0, _react.useState)(!!_tableContext.eventHub.getState('data').length),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    hasData = _useState4[0],
    setHasData = _useState4[1];
  function getDefaultColumns() {
    return _Helpers.Utils.prepareTableColumn(props.columns, props);
  }
  (0, _react.useEffect)(function () {
    var unsubscriber = [_tableContext.eventHub.on('update.columns', setColumns), _tableContext.eventHub.on('update.data', function (data) {
      setHasData(!!data.length);
    })];
    return function () {
      unsubscriber.forEach(function (fn) {
        return fn();
      });
    };
  }, []);
  var parentRef = _react.default.useRef();
  var tableRef = (0, _react.useRef)(null);
  var sizeClass = props.size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, " ").concat(prefixCls, "-default ").concat(defaultWrapperClass, " ").concat(prefixCls, "-").concat(sizeClass, "  ").concat(!hasData ? "".concat(prefixCls, "-empty") : '', " ")
  }, /*#__PURE__*/_react.default.createElement(_TableTitle.default, {
    prefixCls: prefixCls,
    title: props.title
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: parentRef,
    className: "".concat(prefixCls, "-container ").concat(containerWrapperClass),
    style: {
      background: '#fff',
      overflow: 'auto',
      height: scroll === null || scroll === void 0 ? void 0 : scroll.y
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, /*#__PURE__*/_react.default.createElement("table", {
    ref: tableRef
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: "".concat(prefixCls, "-thead")
  }, /*#__PURE__*/_react.default.createElement(_RenderHeaderGroup.default, {
    prefixCls: prefixCls,
    columns: columns,
    onExpandByFilter: onExpandByFilter
  })), /*#__PURE__*/_react.default.createElement("tbody", {
    className: "".concat(prefixCls, "-tbody ").concat(!hasData ? "".concat(prefixCls, "-tbody-empty") : '')
  }, !hasData && /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    colSpan: columns.length,
    height: scroll === null || scroll === void 0 ? void 0 : scroll.y
  }, emptyText)), /*#__PURE__*/_react.default.createElement(_FormRows.default, {
    key: "Formrows",
    rowStyle: props.rowStyle
  }))))), /*#__PURE__*/_react.default.createElement(_TableFooter.default, {
    prefixCls: prefixCls,
    footer: props.footer
  }));
}
EmreTable.defaultProps = {
  size: 'default',
  flattenData: [],
  defaultWrapperClass: 'editable-cell',
  containerWrapperClass: '',
  pagination: false,
  subRows: 'children',
  virtualScroll: true,
  expandedRowKeys: {},
  defaultSorting: [],
  rowKey: 'key',
  onSortingChange: function onSortingChange() {},
  onColumnFiltersChange: function onColumnFiltersChange() {},
  manualSorting: false,
  onChange: function onChange(pagination, filters, sorting) {},
  expandable: {
    onExpand: function onExpand(expandedState, expanded) {},
    onExpandedRowsChange: function onExpandedRowsChange(expandedState, expanded) {},
    defaultExpandedRowKeys: {},
    defaultExpandAllRows: false
  },
  emptyText: 'No data',
  rowSelection: {
    type: 'checkbox',
    enableRowSelection: false,
    checkStrictly: false,
    defaultSelectedRowKeys: {},
    onChange: function onChange(selectedKeys) {}
  },
  scroll: {
    x: 'auto',
    y: 'auto'
  },
  virtualSettings: {
    overscan: 1
  },
  resetFilters: function resetFilters(table, preparedColumns) {},
  getTableMethods: function getTableMethods() {}
};
var _default = exports.default = EmreTable;